import { IAbExperiment } from '../../types/abUseExperiments';
import { getExperiment } from '../getExperiment';

export const getExperimentGroup = (experiments: IAbExperiment[], experimentName: string) => {
  const experiment = getExperiment(experiments, experimentName);

  return experiment?.groupName ?? null;
};
